import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import styles from './BottomNav.module.css';

export interface NavItem {
  /** Route path to navigate to. */
  to: string;
  /** Icon element (SVG component). */
  icon: ReactNode;
  /** Translated label string. */
  label: string;
}

interface BottomNavProps {
  /** Navigation items to render. */
  items: NavItem[];
}

/**
 * Bottom navigation bar for compact (mobile) screens.
 * Fixed at the bottom of the viewport with icon + label layout.
 */
export function BottomNav({ items }: BottomNavProps) {
  return (
    <nav className={styles.bottomNav} aria-label="Main navigation">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            cn(styles.navItem, isActive && styles.active)
          }
        >
          <span className={styles.iconWrap} aria-hidden="true">
            {item.icon}
          </span>
          <span className={styles.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
